const contentWithSidebarInit = (block) => {
    const sidebars = block
        ? Array.from(block[0].querySelectorAll('.bn-cws'))
        : Array.from(document.querySelectorAll('.bn-cws'));

    if (!sidebars.length) return;

	sidebars.forEach((sidebar) => {
		const contactLinks = sidebar.querySelectorAll('a[href="#contact-us"]');
		contactLinks.forEach((link) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const formSection = document.querySelector('section:has(.bn-contact-form)');
				if (formSection) {
					formSection.scrollIntoView({ behavior: 'smooth' });
				}
			});
		});
	});

};


document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        contentWithSidebarInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/content-with-sidebar', contentWithSidebarInit);
});